<template>
  <div class="scanTable">
    <div class="feet-s mb10 fr">
      <UploadCmp
        :auto-upload="true"
        :show-file-list="false"
        :is-check-file-type="true"
        :file-size="50"
        :limit="20"
        :tips="$t('basicData.SupportedFileFormats')"
        :btn-name="$t('GlobalSetObj.Upload')"
        @change="onFileChange"
      />

      <el-button
        :disabled="!tableData.length"
        type="primary"
        size="small"
        icon="el-icon-download"
        @click="batchDownloadFile"
      >{{ $t('orderCenterCont.BulkDownload') }}</el-button>
    </div>

    <el-table
      :data="fileList"
      border
    >
      <!--        文件名-->
      <el-table-column :label="$t('basicData.fileName')" min-width="280" prop="fileOriginalName" />
      <!--        状态-->
      <el-table-column :label="$t('basicData.status')" min-width="100" prop="status">
        <template slot-scope="scope">
          <span>{{ scope.row.status ? $t('basicData.Ineffective') : $t('basicData.Effective') }}</span>
        </template>
      </el-table-column>
      <!--        上传时间-->
      <el-table-column :label="$t('orderDetails.UploadTime')" min-width="140" prop="uploadTime" />

      <!--  操作-->
      <el-table-column
        :label="$t('basicData.operate')"
        align="center"
        width="220"
        fixed="right"
      >
        <template #default="scope">
          <div class="flex">
            <el-button
              v-if="scope.row.status"
              type="primary"
              size="mini"
              @click="changeVoid(0, scope)"
            >{{ $t('basicData.Effective') }}</el-button>
            <el-button
              v-else
              type="danger"
              size="mini"
              @click="changeVoid(1, scope)"
            >{{ $t('basicData.Ineffective') }}</el-button>

            <el-button
              class="feet-btn"
              size="mini"
              @click="previewFile(scope)"
            >{{ $t('operationCenter.Preview') }}</el-button>

            <el-button
              class="feet-btn"
              type="info"
              size="mini"
              @click="downloadFile(scope.row)"
            >{{ $t('GlobalSetObj.Download') }}</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <!-- 文件预览对话框 -->
    <FilePreview
      v-if="showPreviewDialog" :file-list="currenFileList" :file-index="currentPreviewFile"
      @close="closeViewer"
    />
  </div>
</template>

<script>
import UploadCmp from '@/views/claimsManagement/claimStatement/cmp/UploadCmp.vue';
import { debounce } from 'lodash-es';
import { apiContractBatchDownload } from '@/api/finance/contractLedger';
import { goFinanceExportPage } from '@/utils/goExportList';

export default {
  name: 'ScanTable',

  components: {
    UploadCmp,
    FilePreview: () => import('@/views/finance/basicData/cope/accountsPayable/cmp/filePreview.vue')
  },

  props: {
    // 文件列表
    tableData: {
      type: Array,
      default: () => []
    },
    // 合同id
    id: {
      type: Number,
      default: null
    }
  },

  data() {
    return {
      fileList: [],
      // 文件预览相关
      showPreviewDialog: false,
      currenFileList: [],
      currentPreviewFile: 0
    };
  },

  computed: {

  },

  watch: {
    tableData: {
      handler(val) {
        if (val.length === 0) {
          // 初始化为空数组
          this.fileList = [];
          return;
        }
        // 确保每个元素都有 bList 属性
        this.fileList = val;
      },
      immediate: true
    }
  },

  methods: {
    // 改变文件状态-作废
    // 0-生效 1-失效
    changeVoid(type, scope) {
      const { $index } = scope;

      this.fileList[$index].status = type;

      // 改变状态
      // apiContractInvalid(id).then(res => {
      //   if (res.code === 200) {
      //     this.$message.success(this.$t('basicData.TheOperationSucceeded'));
      //   }
      // }).catch(err => {
      //   console.error('修改失败:', err);
      // });
    },

    // 上传回调
    onFileChange(Files) {
      console.log(Files, '上传回调');

      // 获取当前时间 年月日 时分秒
      const now = new Date();
      const uploadTime = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')} ${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}:${String(now.getSeconds()).padStart(2, '0')}`;

      Files.forEach(file => {
        this.fileList.push({
          fileOriginalName: file.name,
          filePath: file.url,
          uploadTime,
          status: 0
        });
      });
    },

    // 回调函数
    getFileList() {
      return this.fileList;
    },

    // 重置
    clearSelection() {
      this.fileList = [];
    },

    /**
     * 文件预览
     * @param scope 行数据
     */
    previewFile(scope) {
      const { row, $index: index } = scope;
      console.log(row, index);
      try {
        this.currentPreviewFile = 0;
        this.currenFileList = [row.filePath] || [];
        this.showPreviewDialog = true;
      } catch (error) {
        console.error(error);
      }
    },

    /**
     * 下载文件
     */
    downloadFile: debounce(async function(row) {
      const url = row.filePath;
      const fileName = url.split('/').pop().split('?')[0];
      try {
        const response = await fetch(url);
        if (!response.ok) {
          this.$message.error(`Network response was not ok: ${response.statusText}`);
          this.loading = false;
          return;
        }

        const blob = await response.blob();

        // 下载逻辑
        const triggerDownload = (dataBlob) => {
          const downloadElement = document.createElement('a');
          const objectURL = window.URL.createObjectURL(dataBlob);

          downloadElement.href = objectURL;
          downloadElement.download = fileName || '';
          document.body.appendChild(downloadElement);
          downloadElement.click();

          // 清理资源
          setTimeout(() => {
            window.URL.revokeObjectURL(objectURL);
            document.body.removeChild(downloadElement);
          }, 0);
        };

        triggerDownload(blob); // 触发下载
      } catch (error) {
        console.log('解析失败:', error);
        this.$message.error('文件链接失效！');
      }
    }, 500),

    // 关闭查看图片
    closeViewer() {
      this.showPreviewDialog = false;
    },

    // 批量下载
    async batchDownloadFile() {
      if (!this.fileList || this.fileList.length === 0) {
        this.$message.warning(this.$t('basicData.NoFilesToDownload') || '没有可下载的文件');
        return;
      }

      const loading = this.$loading({
        lock: true,
        text: (this.$t('basicData.Downloading') || '正在打包下载') + '...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      try {
        const res = await apiContractBatchDownload(this.id);
        if (res.code === 200) {
          goFinanceExportPage().then(flag => {
            if (flag) {
              this.$emit('close');
            }
          });
        }
      } catch (error) {
        this.$message.error(this.$t('basicData.BatchDownloadFailed') || '批量下载失败，请重试');
      } finally {
        loading.close();
      }
    },

    // 下载单个文件
    async downloadSingleFile(file) {
      const url = file.filePath;
      const fileName = file.fileOriginalName || url.split('/').pop().split('?')[0] || 'download';

      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`Network response was not ok: ${response.statusText}`);
      }

      const blob = await response.blob();
      const downloadElement = document.createElement('a');
      const objectURL = window.URL.createObjectURL(blob);

      downloadElement.href = objectURL;
      downloadElement.download = fileName;
      document.body.appendChild(downloadElement);
      downloadElement.click();

      // 清理资源
      setTimeout(() => {
        window.URL.revokeObjectURL(objectURL);
        document.body.removeChild(downloadElement);
      }, 100);
    }
  }
};
</script>

<style scoped lang="scss">
.flex {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.fr {
  display: flex;
  flex-direction: row;
}
</style>
